module.exports = __webpack_public_path__ + "static/media/channel.70f22550.svg";